module.exports = __webpack_public_path__ + "img/store_t-shirt-2.c0d6b684.png";